<template>
  <div>
    <h1 class="display-3">Tablice Epitafijne Okręgu Wileńskiego</h1><br/>
    <b-row>
      <b-col cols="11">

        <div class="mb-5" v-for="table in tables" :key="table.id">
          <p class="text-center display-4">{{table.city}}</p>
          <b-row align-h="center">
            <b-col cols="10" xl="6" >
              <b-carousel class="carousel"
                style="text-shadow: 1px 1px 2px #333; margin: 0 0em 2em 0em;"
                controls
                indicators
                background="#ababab"
                :interval="0"
              >
                <div v-for="carousel in table.carousel" :key="carousel.id">
                  <b-carousel-slide
                    :caption="carousel.title"
                    :text="carousel.text"
                    :img-src="carousel.img"
                  ></b-carousel-slide>
                </div>
              </b-carousel>
            </b-col>
          </b-row>
        </div>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import tablice_epitafijne from '@/models/historia/tablice_epitafijne'

export default {
  name: 'tablice_epitafijne',
  data: function(){
    return{
      tables: tablice_epitafijne.tables
    }
  },
  metaInfo:{
    title: 'Tablice Epitafijne Okręgu Wileńskiego',
    meta:[
      {name: 'description', content: 'Zdjęcia tablic epitafijnych Okręgu Wileńskiego z podziałem na miasta, w których się znajdują oraz z opisem dokładnej lokalizacji poszczególnych tablic' },
      {name: 'og:url', content: 'http://akwilno.pl/historia/tablice_epitafijne' },
      {name: 'og:title', content: 'Tablice Epitafijne Okręgu Wileńskiego' },
      {name: 'og:image', content: '/historia/tablice_epitafijne.jpg' },
      {name: 'og:description', content: 'Zdjęcia tablic epitafijnych Okręgu Wileńskiego z podziałem na miasta, w których się znajdują oraz z opisem dokładnej lokalizacji poszczególnych tablic' },
      {name: 'twitter:url', content: 'http://akwilno.pl/historia/tablice_epitafijne' },
      {name: 'twitter:title', content: 'Tablice Epitafijne Okręgu Wileńskiego' },
      {name: 'witter:image', content: '/historia/tablice_epitafijne.jpg' },
      {name: 'twitter:description', content: 'Zdjęcia tablic epitafijnych Okręgu Wileńskiego z podziałem na miasta, w których się znajdują oraz z opisem dokładnej lokalizacji poszczególnych tablic' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/historia/tablice_epitafijne.vue